import React from "react";
import { StyledFormElementsWrapper, ContainerGrid } from "../styles";
import FormField from "../../../common/FormField/FormField";
import CustomSelect from "./CustomSelect";
import styled from "styled-components";
import theme from "../../../../assets/theme";
import COLORS from "../../../../assets/Colors";

const TemplateDelete = ({
  values,
  handleChange,
  errors,
  touched,
  handleBlur,
  setFieldValue,
  menuItems,
  menuNotice,
  menuTemplateCode,
  getNoticeTemplates,
  getNoticeTemplate,
}) => {
  const selectedTemplate = menuTemplateCode[values?.noticeCategory]?.find(
    (template) => template?.templateCode === values?.templateCode,
  );

  const handleCategoryChange = (event) => {
    setFieldValue("noticeCategory", event.target.value);
    setFieldValue("templateCode", "");
  };

  const handleTemplateChange = async (event) => {
    const template = menuTemplateCode[values?.noticeCategory]?.find(
      (item) => String(item?.id) === String(event.target.value),
    );
    setFieldValue("templateCode", template?.templateCode || "");
    if (template?.id) await getNoticeTemplate(template.id);
  };

  const inputs = [
    {
      type: "select",
      name: "noticeCategory",
      label: "Notice Category",
      required: false,
      items: menuNotice,
      onChange: handleCategoryChange,
    },
    {
      type: "select",
      name: "templateCode",
      label: "Template Code",
      required: false,
      value: selectedTemplate?.id || "",
      onChange: handleTemplateChange,
      items: menuTemplateCode[values?.noticeCategory]?.length
        ? menuTemplateCode[values?.noticeCategory]?.map(
            ({ id, templateCode, historyDisplay }) => ({
              id,
              label: templateCode,
              value: id,
              historyDisplay,
            }),
          )
        : [],
    },
  ];

  return (
    <>
      <StyledFormElementsWrapper style={{ marginBottom: 8, marginTop: 15 }}>
        <SectionTitle>
          <SectionIcon>{"🗑️"}</SectionIcon>
          Delete Notice Template
        </SectionTitle>

        <WarningBanner>
          <WarningIcon>{"⚠️"}</WarningIcon>
          <WarningText>
            This action is irreversible. Please confirm the template you want to
            delete.
          </WarningText>
        </WarningBanner>

        <ContainerGrid className="disabledArrows">
          <CustomSelect
            name="partyId"
            trigger={true}
            value={values["partyId"]}
            {...{
              errors,
              touched,
              setFieldValue,
              menuItems,
              getNoticeTemplates,
            }}
          />
          {inputs.map((input, index) => (
            <FormField
              key={index}
              menuItems={input.items}
              {...{
                touched,
                errors,
                input,
                values,
                handleChange,
                handleBlur,
                setFieldValue,
              }}
            />
          ))}
        </ContainerGrid>
      </StyledFormElementsWrapper>
    </>
  );
};

export default TemplateDelete;

const SectionTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 16px;
  font-weight: 700;
  color: ${COLORS.COLOR_DARK};
  margin-bottom: 20px;
  padding-bottom: 14px;
  border-bottom: 1.5px solid rgba(0, 131, 140, 0.1);
`;

const SectionIcon = styled.span`
  width: 32px;
  height: 32px;
  background: linear-gradient(
    135deg,
    rgba(217, 27, 27, 0.1),
    rgba(255, 60, 60, 0.1)
  );
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
`;

const WarningBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  background: linear-gradient(135deg, #fff7ed, #fef3c7);
  border: 1.5px solid #fde68a;
  border-radius: 12px;
  padding: 14px 18px;
  margin-bottom: 24px;
`;

const WarningIcon = styled.span`
  font-size: 20px;
  flex-shrink: 0;
`;

const WarningText = styled.span`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 13px;
  color: #92400e;
  line-height: 1.5;
`;
